var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.phoneData),function(item,index){return (index < 2)?[_c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"mb-1 badge badge-round badge-light"},[_vm._v(_vm._s(item.value))])])]:_vm._e()})],2)}
var staticRenderFns = []

export { render, staticRenderFns }